export default __webpack_public_path__ + "static/media/뜨개질_모바일.5e44657b.jpg";